<div class="scrollable-section" #scrollableSection>

  <div *ngIf="loadingA3Doc" class="custom-loading-container">
    <div class="custom-loading-message">
      <div class="loader"></div>
      <span>Conectando con A3Doc Cloud</span>
    </div>
  </div>

  <!-- TIPO DOCUMENTI -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button" (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>
  <br><br>

  <dx-data-grid #dataGrid id="gridContainer" [dataSource]="dataSource" [selectedRowKeys]="docsSelected" keyExpr="id"
    (onContentReady)="onContentReady($event)" (onToolbarPreparing)="onToolbarPreparing($event)"
    (onEditorPreparing)="onEditorPreparing($event)" (onCellPrepared)="onCellPrepared($event)"
    (onSelectionChanged)="onSelectionChanged($event)">

    <!-- Definición de las columnas -->
    <dxo-selection mode="multiple" showCheckBoxesMode="always" caption="Seleccionar"></dxo-selection>

    <dxi-column dataField="id" caption="Id" [visible]="false"></dxi-column>
    <dxi-column dataField="title" caption="Nombre del documento"></dxi-column>
    <dxi-column dataField="customerName" caption="Empresa"> </dxi-column>
    <dxi-column dataField="containersNames" caption="Categoría" alignment="center" [allowFiltering]="true"></dxi-column>
    <dxi-column dataField="date" caption="Creación" alignment="center" [allowFiltering]="false"
      [allowHeaderFiltering]="false " dataType="date" format="dd/MM/yyyy" [sortOrder]="'desc'">
    </dxi-column>

    <dxi-column caption="Acciones" [allowFiltering]="false" [allowSorting]="false" alignment="center"
      cellTemplate="viewDoc"></dxi-column>
    <ng-container *dxTemplate="let data of 'viewDoc'">
      <button rel="tooltip" type="button" class="btn btn-action" (click)="onFileOpen(data.data.docData)">
        <i class="material-icons">remove_red_eye</i>
      </button>
    </ng-container>

  </dx-data-grid>
  <!-- Botonera -->
  <div class="row col-12 float-right ">
    <label class="col-12"></label>
    <div class="col-12">
      <div class="form-group form-button">
        <button class="btn btn-fill btn-primary float-right" type="submit" (click)="onSubmitDocs()">Publicar</button>
        <a class="btn btn-fill btn-outline-white button-white float-right" (click)="closePopUp(false)">Volver</a>
      </div>
    </div>
  </div>
</div>